const data = {
  title: "Floor 2-1",
  musicTrack: "MUSIC_WORLD2",
  story: "FLOOR TWO - CAMPUS GARDENS",
  theme: "GREEN",
  tilesWidth: 11,
  tilesHeight: 6,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 2,
    },
    {
      type: "WALL",
      x: 2,
      y: 4,
    },
    {
      type: "WALL",
      x: 3,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 1,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 6,
    },
    {
      type: "WALL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 7,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "WALL",
      x: 5,
      y: 6,
    },
    {
      type: "WALL",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 3,
      y: 6,
    },
    {
      type: "WALL",
      x: 2,
      y: 6,
    },
    {
      type: "WALL",
      x: 1,
      y: 6,
    },
    {
      type: "WALL",
      x: 11,
      y: 4,
    },
    {
      type: "WALL",
      x: 10,
      y: 4,
    },
    {
      type: "WALL",
      x: 10,
      y: 6,
    },
    {
      type: "WALL",
      x: 11,
      y: 6,
    },
    {
      type: "WALL",
      x: 5,
      y: 4,
    },
    {
      type: "SWITCH",
      x: 6,
      y: 4,
    },
    {
      type: "SWITCH_WALL",
      x: 4,
      y: 5,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 5,
      isRaised: false,
    },
    {
      type: "CHIP",
      x: 3,
      y: 5,
    },
    {
      type: "CHIP",
      x: 9,
      y: 5,
    },
    {
      type: "ENEMY_SPAWN",
      x: 11,
      y: 5,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
  ],
};

export default data;
